// extracted by mini-css-extract-plugin
export var addressFields = "_ng-0";
export var animationContainer = "_ng-1";
export var footer = "_ng-2";
export var lineItems = "_ng-3";
export var modalContent = "_ng-4";
export var orderName = "_ng-5";
export var strong = "_ng-6";
export var warning = "_ng-7";